import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    MobileStepper,
} from '@material-ui/core';
import {P} from 'components/TypographyShortcuts';
import React, {useContext, useState} from 'react';
import CredentialPage from './CredentialPage';
import {PBold} from 'components/TypographyShortcuts';
import {KeyboardArrowLeft, KeyboardArrowRight} from '@material-ui/icons';
import {DeleteDocumentPicture} from 'components/icons/icons';
import {UserContext} from 'context/UserContext';
import {useHistory} from 'react-router-dom';
import useBrowserTitle from 'hooks/useBrowserTitle';
import Show from 'components/utils/Show';
import {
    IntroVideoWith,
    IntroVideoWithout,
    HasMMCPage,
    HomeScreenWith,
    HomeScreenWithout,
    MMCLookupPage,
} from './onboard/index';
import useWindowSize from 'hooks/useWindowSize';
import {useTheme} from '@material-ui/core/styles';
import {AppCtx} from 'context/AppContext';

const AddingDocuments = () => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <PBold align='center'>Adding Documents</PBold>
            </Grid>
            <Grid item xs={12}>
                <PBold paragraph={false} align='center'>
                    From the Checklist
                </PBold>
                <P>
                    You can also add documents within the Checklist you are
                    working on.
                </P>
            </Grid>
            <Grid item xs={12}>
                <PBold paragraph={false} align='center'>
                    Add Button
                </PBold>
                <P>
                    You can use the Add button on the top right to add your
                    documentation of sea service, your USCG Approved Course
                    Certificates and the additional documents you need for your
                    USCG License application.
                </P>
            </Grid>
        </Grid>
    );
};

const SafeStorage = () => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <PBold align='center'>Safe Document Storage</PBold>
            </Grid>
            <Grid item xs={12}>
                <PBold paragraph={false} align='center'>
                    Sea Service
                </PBold>
                <P>
                    The Sea Service page has seperate tabs that show you where
                    you currently sit for vessels and positions based on the sea
                    service you have entered.
                </P>
            </Grid>
            <Grid item xs={12}>
                <PBold paragraph={false} align='center'>
                    My Documents
                </PBold>
                <P>
                    The My Documents page shows all of your Sea Service,
                    Training and Supporting Documents that you have entered into
                    MM-SEAS.
                </P>
            </Grid>
        </Grid>
    );
};

const DeletingEditing = () => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <PBold align='center'>Deleting and Editing</PBold>
            </Grid>
            <Grid item xs={12}>
                <PBold paragraph={false} align='center'>
                    Mistakes Happen
                </PBold>
            </Grid>
            <Grid item xs={12}>
                <DeleteDocumentPicture width='100%' />
            </Grid>
            <Grid item xs={12}>
                <P>
                    If you made a mistake you can Delete the document and
                    re-enter it with the correct information!
                </P>
            </Grid>
        </Grid>
    );
};

const YourAccount = () => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <PBold align='center'>Your Account</PBold>
            </Grid>
            <Grid item xs={12}>
                <PBold paragraph={false} align='center'>
                    My Profile
                </PBold>
                <P>
                    The My Profile page has seperate tabs for your CG-719B
                    profile., your current Subscription Information, your
                    Payment Information and your Account Settings.
                </P>
            </Grid>
            <Grid item xs={12}>
                <PBold paragraph={false} align='center'>
                    Settings
                </PBold>
                <P>
                    Referrals, Subscription Information, Payment Information and
                    your Account Settings are easily accesible. In the Account
                    Settings there is a Download My Data button which allows you
                    to always be able to get your valuable documents back out of
                    MM-SEAS when ever you want.{' '}
                </P>
            </Grid>
        </Grid>
    );
};

const ThankYou = () => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <PBold align='center'>
                    We really appreicate you being part of MM-SEAS.
                </PBold>
            </Grid>
            <Grid item xs={12}>
                <P>
                    If you ever have any ideas for ways we can make the USCG
                    Licensing process even easier please reach out. The easiest
                    way is to click on the red Contact button in the menu on the
                    left.
                </P>
            </Grid>
        </Grid>
    );
};

const OnboardContent = ({
    title = 'Show Welcome Tutorial',
    hideButton = false,
    inForm,
    setShowGetStartedButton = () => {},
    children,
}) => {
    const [open, setOpen] = useState(false);
    const {profile} = useContext(UserContext);
    const {showWelcomeTutorial, setShowWelcomeTutorial} = useContext(AppCtx);
    const [hasMMC, setHasMMC] = useState(profile?.applicant_previous_mmc);
    const [pageOn, setPageOn] = useState(0);
    const askMMC = inForm ? [HasMMCPage] : [];
    const withPages = [
        ...askMMC,
        IntroVideoWith,
        MMCLookupPage,
        HomeScreenWith,
        AddingDocuments,
        SafeStorage,
        DeletingEditing,
        YourAccount,
        ThankYou,
    ];
    const withoutPages = [
        ...askMMC,
        IntroVideoWithout,
        HomeScreenWithout,
        AddingDocuments,
        SafeStorage,
        DeletingEditing,
        YourAccount,
        ThankYou,
    ];
    const pages = hasMMC ? withPages : withoutPages;
    const Page = pages[pageOn];
    setShowGetStartedButton(inForm && pageOn !== 0);
    const goNextPage = () => {
        setPageOn(pageOn + 1);
    };

    const {width} = useWindowSize();
    const forceOpen = inForm || showWelcomeTutorial;
    const content =
        !forceOpen && !hideButton
            ? [
                  <Button onClick={() => setOpen(true)} key='open'>
                      {title}
                  </Button>,
              ]
            : [];

    content.push(
        <Dialog
            open={forceOpen || open}
            BackdropProps={{
                style: {
                    backdropFilter: 'blur(3px)',
                },
            }}
            PaperProps={{
                style: {
                    height: '80%',
                    maxHeight: '80%',
                    minHeight: '80%',
                    margin: width < 400 ? '32px 0px' : null,
                },
            }}
            onClose={() => {
                setOpen(!open);
                setShowWelcomeTutorial(false);
            }}
            key='dialog'
        >
            <DialogTitle align='center'>Welcome to MM-SEAS!</DialogTitle>
            <DialogContent>
                <Page
                    setHasMMC={setHasMMC}
                    hasMMC={hasMMC}
                    goNextPage={goNextPage}
                />
                {children}
            </DialogContent>
            <Show condition={!inForm || pageOn !== 0}>
                <DialogActions>
                    <MobileStepper
                        variant='dots'
                        steps={pages.length}
                        activeStep={pageOn}
                        position='static'
                        style={{flexGrow: 1}}
                        nextButton={
                            <Button
                                onClick={() => setPageOn(pageOn + 1)}
                                disabled={pageOn === pages.length - 1}
                            >
                                Next
                                <KeyboardArrowRight />
                            </Button>
                        }
                        backButton={
                            <Button
                                onClick={() => setPageOn(pageOn - 1)}
                                disabled={pageOn === 0}
                            >
                                <KeyboardArrowLeft />
                                Back
                            </Button>
                        }
                    />
                </DialogActions>
            </Show>
        </Dialog>
    );

    return content;
};

const OnboardForm = () => {
    const {actions} = useContext(UserContext);
    const history = useHistory();
    const [showGetStartedButton, setShowGetStartedButton] = useState(true);
    const theme = useTheme();

    const register = () => {
        window.dataLayer.push({
            event: 'user_subscription',
            data: {
                subPeriod: 'monthly',
                subType: 'pro',
                promoCode: null,
            },
        });
        actions.register();
        history.push('/home');
    };

    return (
        <OnboardContent
            inForm
            setShowGetStartedButton={setShowGetStartedButton}
        >
            <Show condition={showGetStartedButton}>
                <Box marginTop='1em' textAlign='center'>
                    <Button
                        style={{
                            color: theme.palette.success.main,
                        }}
                        onClick={register}
                    >
                        <PBold>"I'm ready to get started!"</PBold>
                    </Button>
                </Box>
            </Show>
        </OnboardContent>
    );
};

const OnboardPage = () => {
    useBrowserTitle('| Onboard');
    return [
        <CredentialPage key='background-page' useTitle={false} />,
        <OnboardForm key='in-focus-tutorial' />,
    ];
};

export default OnboardPage;
export {OnboardContent};
